module.exports = __webpack_public_path__ + "img/02.2c8119a9.svg";